import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { ToastService } from 'src/app/services/toast.service';
import { EClothingSize, EShoeSize } from 'src/app/enum/size.enum';
import { EProductType, IProduct } from 'src/app/models/product.model';
import { environment } from 'src/environments/environment';
import { IConfirmData } from 'src/app/models/confirm-data';

@Component({
  selector: 'app-shop-dialog',
  templateUrl: './shop-dialog.component.html',
  styleUrl: './shop-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ShopDialogComponent {
  @Input() product: IProduct;
  @Input() selectedImage: string = null;

  @Output() closeDialog: EventEmitter<any> = new EventEmitter();
  @Output() acceptDialog: EventEmitter<any> = new EventEmitter();

  public showSizeDropdown = false;
  public dropDownIcon = faAngleDown;
  public EProductType = EProductType;
  public EClothingSize = EClothingSize;
  public environment = environment;
  public confirmData: IConfirmData = {} as IConfirmData;
  public confirmDialog = false;

  constructor(private toastService: ToastService) {}

  public getClothingSizes(): EClothingSize[] {
    const sizes = Object.values(EClothingSize).filter((value) => typeof value === 'string') as EClothingSize[];
    return Object.values(EClothingSize).filter((value) => typeof value === 'string') as EClothingSize[];
  }
  public getShoeSizes(): EShoeSize[] {
    return Object.values(EShoeSize).filter((value) => typeof value === 'string') as EShoeSize[];
  }

  public onSelectSize(size: EClothingSize | EShoeSize) {
    this.product.size = size;
    this.showSizeDropdown = false;
  }

  public openConfirmDialog(): void {
    this.confirmData.headline = 'Buy this product?';
    this.confirmData.text = `Are you sure you want to buy "${this.product.title}" for ${this.product.price} Coins?`;
    this.confirmData.image = 'basket';
    this.confirmDialog = true;
  }

  public onBuyProduct() {
    if (
      (this.product.type === EProductType.CLOTHING || this.product.type === EProductType.FOOTWEAR) &&
      !this.product.size
    ) {
      this.toastService.error('Please select a size first');
      return;
    }

    this.acceptDialog.emit(this.product);
    this.closeDialog.emit();
  }

  public onCloseDialog() {
    this.closeDialog.emit();
  }

  public onToggleDropDown(): void {
    this.showSizeDropdown = !this.showSizeDropdown;
  }
}
